require('./RASuitabilityTestResultChangeModal.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('commonsComponents/OKModal');
const RAStrategyModalCards = require('../RAStrategyModalCards/RAStrategyModalCards');

// @utilites
const { FormattedText, formatText } = require('core/i18n').i18n;

class RASuitabilityTestResultChangeModal extends React.Component {
    render() {
        const {
            isOpen,
            onModalToggle,
            newMaxTypeOfProduct,
            oldMaxTypeOfProduct,
            onReviseButtonClick,
        } = this.props;

        const modalTitle = formatText(
            'raSuitabilityTestResultChangeModal-raSuitabilityTestResultChangeModal_title',
        );

        const modalContent = (
            <div className="ra-suitability-test-result-change-modal__content-container">
                <div className="ra-suitability-test-result-change-modal__text">
                    <FormattedText
                        className="ra-suitability-test-result-change-modal__text"
                        value="raSuitabilityTestResultChangeModal-raSuitabilityTestResultChangeModal_descriptionText"
                    />
                </div>
                <div className="ra-suitabilty-test-result-change-modal__cards-container">
                    <RAStrategyModalCards
                        newResultCard={newMaxTypeOfProduct}
                        oldResultCard={oldMaxTypeOfProduct}
                    />
                </div>
            </div>
        );
        const footerContent = (
            <div className="ra-suitability-test-result-change-modal__buttons-container">
                <div className="ra-suitability-test-result-change-modal__button">
                    <OKButton
                        modifier="primary"
                        size="regular"
                        onClick={onReviseButtonClick}
                    >
                        <FormattedText value="raSuitabilityTestResultChangeModal-raSuitabilityTestResultChangeModal_reviseAnswersButton" />
                    </OKButton>
                </div>
                <div className="ra-suitability-test-result-change-modal__button">
                    <OKButton
                        modifier="secondary"
                        size="regular"
                        onClick={onModalToggle}
                    >
                        <FormattedText value="raSuitabilityTestResultChangeModal-raSuitabilityTestResultChangeModal_CTAButton" />
                    </OKButton>
                </div>
            </div>
        );
        return (
            <OKModal
                isOpen={isOpen}
                contentOverflow="auto"
                title={modalTitle}
                shouldCloseOnOverlayClick={false}
                titleAlignment="center"
                onCloseCallback={onModalToggle}
                content={modalContent}
                size="large"
                contentFooter={footerContent}
            />
        );
    }
}

RASuitabilityTestResultChangeModal.propTypes = {
    isOpen: PropTypes.bool,
    newMaxTypeOfProduct: PropTypes.number,
    oldMaxTypeOfProduct: PropTypes.number,
    onModalToggle: PropTypes.func,
    onReviseButtonClick: PropTypes.func,
};

module.exports = RASuitabilityTestResultChangeModal;
